export default function CurrentResult(){

}